'use client';

import { FreeMode, Pagination } from 'swiper/modules';
import { Swiper } from 'swiper/react';

import type { ReactNode } from 'react';

export const Carousel = ({
  children,
  hasPagination = true,
  slidesPerView = 1.1,
  centeredSlides = true,
  spaceBetween = 12,
  className = '',
}: {
  spaceBetween?: number;
  slidesPerView?: number;
  hasPagination?: boolean;
  centeredSlides?: boolean;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Swiper
      pagination={
        hasPagination
          ? {
              clickable: true,
            }
          : undefined
      }
      freeMode
      spaceBetween={spaceBetween}
      modules={[FreeMode, Pagination]}
      slidesPerView={slidesPerView}
      centeredSlides={centeredSlides}
      className={className}
    >
      {children}
    </Swiper>
  );
};
